import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { SpinnerService } from "@elotech/angular-common";
import { finalize } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class S3Service {

  private readonly SERVER_SIDE_ENCRYPTION_CUSTOMER_ALGORITHM = "x-amz-server-side-encryption-customer-algorithm";
  private readonly SERVER_SIDE_ENCRYPTION_CUSTOMER_KEY = "x-amz-server-side-encryption-customer-key";
  private readonly SERVER_SIDE_ENCRYPTION_CUSTOMER_KEY_MD5 = "x-amz-server-side-encryption-customer-key-MD5";

  private _httpClient = inject(HttpClient);
  private _spinnerService = inject(SpinnerService);

  getArquivoS3(urlSafe: any): Observable<Blob> {
    const headers = urlSafe.customerKey ? {
      [this.SERVER_SIDE_ENCRYPTION_CUSTOMER_ALGORITHM]: urlSafe.customerAlgorithm,
      [this.SERVER_SIDE_ENCRYPTION_CUSTOMER_KEY]: urlSafe.customerKey,
      [this.SERVER_SIDE_ENCRYPTION_CUSTOMER_KEY_MD5]: urlSafe.customerKeyMD5
    } : undefined;

    this._spinnerService.show.emit(true);

    return this._httpClient.get(urlSafe.url, {
      headers,
      responseType: 'blob'
    }).pipe(
      finalize(() => this._spinnerService.show.emit(false))
    );
  }
}
